<template>
  <a href="https://embl.org" target="_blank">
    <img src="./img/embl.png" alt="EMBL" title="EMBL" />
  </a>
</template>

<style scoped>
img {
  height: clamp(26px, 10vw, 70px);
  width: auto;
}
</style>
